import { lazy } from 'react';

export const ZodiacPageLazy = lazy(() => import('./zodiac'));
